import script from "./MeusAgendamentosView.vue?vue&type=script&setup=true&lang=js"
export * from "./MeusAgendamentosView.vue?vue&type=script&setup=true&lang=js"

import "./MeusAgendamentosView.vue?vue&type=style&index=0&id=c74d8822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c74d8822"]])

export default __exports__